module.exports = __webpack_public_path__ + "static/media/resplendentcosmetics.4117caa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/resplendentcosmetics.png
// module id = 58
// module chunks = 0